import CRMProviders from './providers/CRMProviders';
import { CRMErrors } from './constants';
import LoggerWrapper from '../modules/logger-wrapper';

const ActiveProviderClass = CRMProviders;

class CRMManagerClass {
	constructor() {
		this._logger = new LoggerWrapper('CRM', 'CRMManager', LoggerWrapper.INFO);
		this._provider = new ActiveProviderClass();
		this._wrapMethod(() => {
			this._provider.boot();
		});
	}

	isActive = () => {
		this._wrapMethod(() => {
			this._provider.isActive();
		});
	};

	showLauncher = () => {
		this._wrapMethod(() => {
			this._provider.showLauncher();
		});
	};

	hideLauncher = () => {
		this._wrapMethod(() => {
			this._provider.hideLauncher();
		});
	};

	show = () => {
		this._wrapMethod(() => {
			this._provider.show();
		});
	};

	hide = () => {
		this._wrapMethod(() => {
			this._provider.hide();
		});
	};

	showNewMessage = (message) => {
		this._wrapMethod(() => {
			this._provider.showNewMessage(message);
		});
	};

	trackEvent = (event) => {
		this._wrapMethod(() => {
			this._provider.trackEvent(event);
		});
	};

	setProvider = (provider) => {
		this._wrapMethod(() => {
			this._provider.setProvider(provider);
		});
	};

	updateMe = (user, account) => {
		this._wrapMethod(() => {
			this._provider.updateMe(user, account);
		});
	};

	updateUserCompanyData = (user, company) => {
		this._wrapMethod(() => {
			this._provider.updateUserCompanyData(user, company);
		});
	};

	shutDown = () => {
		this._wrapMethod(() => {
			this._provider.shutDown();
		});
	};

	_wrapMethod(method) {
		try {
			if (!this._provider) {
				this._logger.error('crm provider is not initialized');
			}
			method();
		} catch (err) {
			this._handleInvocationError(err);
		}
	}

	_handleInvocationError(err) {
		switch (err.message) {
			case CRMErrors.undefinedProvider:
				this._logger.error('crm provider is undefined');
				break;
			default:
				this._logger.error('crm method invocation error', null, { err });
				break;
		}
	}
}

const CRMManager = new CRMManagerClass();
export default CRMManager;
